import StarterKit from '@tiptap/starter-kit';
import { Markdown } from '@tiptap/markdown';
import { TableKit } from '@tiptap/extension-table';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import Placeholder from '@tiptap/extension-placeholder';
import { common, createLowlight } from 'lowlight';
import type { AnyExtension } from '@tiptap/core';
import type { EditorContext } from '../types';
import { AdoToc, AdoTosp } from './extensions/adoBlocks';
import { AdoQuery } from './extensions/adoQuery';
import { AdoImage } from './extensions/adoImage';
import { Mermaid } from './extensions/mermaid';
import { UserMention } from './extensions/userMention';
import { WorkItemRef } from './extensions/workItemRef';

const lowlight = createLowlight(common);

/**
 * The full extension set. `ctx` is null in tests and headless normalization,
 * where no network calls should happen.
 */
export function buildExtensions(ctx: EditorContext | null): AnyExtension[] {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4, 5] },
      codeBlock: false, // replaced by CodeBlockLowlight
      underline: false, // no markdown equivalent in ADO
      link: { openOnClick: false, autolink: true, defaultProtocol: 'https' },
    }),
    CodeBlockLowlight.configure({ lowlight, defaultLanguage: null }),
    TableKit.configure({ table: { resizable: false } }),
    AdoImage.configure({ ctx, inline: false, allowBase64: false }),
    Placeholder.configure({ placeholder: 'Start writing… Type # for a work item, @ for a person.' }),
    Markdown.configure({ indentation: { style: 'space', size: 2 } }),
    Mermaid,
    AdoToc,
    AdoTosp,
    AdoQuery.configure({ ctx }),
    WorkItemRef.configure({ ctx }),
    UserMention.configure({ ctx }),
  ];
}
